/* eslint-disable no-useless-escape */
/* eslint-disable no-mixed-operators */
import { message, Upload } from "antd";
import { fetchApi } from "../../services/Api";
import { COOKIE, cookiesToDelete, deleteCookie, getCookie } from "../../services/Cookie";
import { fronturls } from "../../constants/FrontendUrls";
import constants from "../../constants/Constants";
import { apiurls } from "../../constants/ApiUrls";
import dayjs from 'dayjs'

export const navigateByUser = (navigate, adminRoute, studentRoute, replace = false, params = {}) => {
	const userType = getCookie(COOKIE.UserType);
	let options = params
	if (replace) options = {
		state: { ...params },
		replace: true
	}
	if (userType === '1') navigate(adminRoute, options);
	else navigate(studentRoute, options);
}

export function myTrim(myString) {
	if (!myString) return '';
	return myString.replace(/^\s+|\s+$/gm, '');
}

export function removeExtraSpaces(myString) {
	if (!myString) return '';
	let tempStr = myTrim(myString);
	return tempStr.replace(/(^\s+|\s+$)/g, '').replace(/&nbsp;/g, ' ').trim();
}

export const handlePasswordValidation = (rule, value, callback) => {
	try {
		if (value) {
			const passwordValidate = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).*$/;
			const isValid = passwordValidate.test(value);
			if (!isValid) {
				callback("Enter strong password");
			} else {
				callback();
			}
		} else {
			callback();
		}
	} catch (err) {
		callback(err);
	}
};

export const getUserType = () => {
	const URL = window.location.pathname
	return URL?.includes("admin")
}

export const logout = (navigate) => {
	const userId = getCookie(COOKIE.UserId);
	const userType = getCookie(COOKIE.UserType);
	let payload = {
		user_type: userType,
		is_logged_in: 0
	}
	fetchApi(`/logout/${userId}`, "POST", payload)
		.then((res) => {
			if (res?.code === 200) {
				cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
				sessionStorage.clear();
				localStorage.clear();
				navigateByUser(
					navigate,
					fronturls.AdminLogin,
					fronturls.Home,
					false
				)
				return
			}
			message.error(res.message);
		}).catch(() => {
			message.error(constants.SomethingWentWrong);
		});
}
export const onlyNumbers = (e) => {
	// Allow: backspace, delete, tab, escape, enter, and arrow keys
	if (
		e.key === "Backspace" ||
		e.key === "Delete" ||
		e.key === "Tab" ||
		e.key === "Escape" ||
		e.key === "Enter" ||
		e.key.startsWith("Arrow")
	) {
		return; // Allow these keys
	}
	// Ensure the input is a number
	if (!/^\d$/.test(e.key)) {
		e.preventDefault(); // Prevent default action if not a number
	}
};

export const performSearch = (search, originalData, fieldNames, isArray) => {
	if (!search) {
		return originalData;
	}
	// Normalize the search string by replacing multiple spaces with a single space
	const normalizedSearch = search?.toLowerCase()?.replace(/\s+/g, ' ')?.trim();

	return originalData?.filter((dataItem) =>
		fieldNames.some((fieldName) => {
			// Normalize the data item's field value by replacing multiple spaces with a single space
			const fieldValue = (!Array.isArray(dataItem?.[fieldName])) ? dataItem?.[fieldName]?.toLowerCase().replace(/\s+/g, ' ').trim() : "";
			return fieldValue?.includes(normalizedSearch) || Array.isArray(dataItem?.[fieldName]) && searchNestedData(dataItem?.[fieldName], search);
		})
	);
}

// Function to recursively search within nested data
const searchNestedData = (data, text) => {
	if (!Array.isArray(data)) return false;

	for (let i = 0; i < data.length; i++) {
		const item = data[i];
		if (typeof item === 'object') {
			const values = Object.values(item);
			for (let j = 0; j < values.length; j++) {
				const value = values[j];
				if (typeof value === 'string' && value.toLowerCase().includes(text.toLowerCase())) {
					return true;
				}
				if (Array.isArray(value) && searchNestedData(value, text)) {
					return true;
				}
			}
		}
	}
	return false;
}

export const checkRoute = () => {
	return window.location.pathname?.toLowerCase()?.includes(constants.Admin.toLowerCase()) ? 1: 0
}

export const handleCheckEmail = (email, alt_email, userType) => {
	return new Promise((resolve) => {
		const payload = {};
		if (email) payload.stud_email = email;
		if (userType) payload.user_type = userType;
		if (alt_email) payload.alternate_stud_email = alt_email;
		if (Object.keys(payload).length === 0) {
			resolve(true);
			return;
		}

		fetchApi(apiurls.ValidEmail, "POST", payload)
			.then((res) => {
				if (res.code === 200) {
					resolve(true);
				} else {
					message.error(res.message);
					resolve(false);
				}
			})
			.catch(() => {
				message.error(constants.EmailError);
				resolve(false);
			});
	});
};

export const handleValidateName = (rule, value, callback) => {
	try {
		if (value) {
			const trimmedValue = value.trim();
			let nameValidate = /[`@#$%^!_&*,<>;?:"\/[\]|{}()=+\d\\]/;
			if (
				trimmedValue.length === 0 ||
				trimmedValue.includes(" ") ||
				nameValidate.test(trimmedValue)
			) {
				throw new Error(constants.FirstNameInvalid);
			}
		}
		callback();
	} catch (err) {
		callback(err);
	}
};

export const handleValidateLastName = (rule, value, callback) => {
	try {
		if (value) {
			const trimmedValue = value.trim();
			let nameValidate = /[`@#$%^!_&*,<>;?:"\/[\]|{}()=+\d\\]/;
			if (trimmedValue.length === 0 || nameValidate.test(trimmedValue)) {
				throw new Error(constants.LastNameInvalid);
			}
		}
		callback();
	} catch (err) {
		callback(err);
	}
};

	export	const getRoleId = (role) => {
		let id;
		switch (role) {
			case "Student":
				id = 1
				break;
			case "Professional":
				id = 2
				break;
			case "Faculty":
				id = 3
				break;
			case "Others":
				id = 4
				break;
			default:
				id = ""
				break;
		}
		return id;
	};

	
export const 	getStartAndEndDate = (month, year) => {
	if (!year) {
		console.error("Year is required");
	}
	let startDate, endDate;
	if (year === "all" && !month) {
		// Fixed start date as "2020-01-01" and end date as the current date
		startDate = dayjs("2020-01-01");
		endDate = dayjs(); // Current date
	} else if (month) {
		// Parse the month and year to get the start and end dates of the month
		startDate = dayjs(`${month} ${year}`, "MMMM YYYY").startOf("month");
		endDate = dayjs(`${month} ${year}`, "MMMM YYYY").endOf("month");
	} else {
		// Get the start and end dates for the entire year
		startDate = dayjs(`${year}`, "YYYY").startOf("year");
		endDate = dayjs(`${year}`, "YYYY").endOf("year");
	}

	// Return the payload
	return {
		start_date: startDate.format(constants.DateFormat3), // Formatting to a standard format
		end_date: endDate.format(constants.DateFormat3)
	};
};

export const beforeImageUpload = (file) => {
	const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
	if (!isJpgOrPng) {
		message.error(constants.InvalidFileFormat);
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		message.error('Maximum file size accepted is 2MB.');
	}
	return isJpgOrPng && isLt2M;
};

export const getBase64 = (file) =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = (error) => reject(new Error(`Error reading file: ${error.message}`));  // Pass an Error object
	});

	export const registrationFilter = (e, setStartDateEndDate, setCurrentYear) => {
		switch (e) {
			case "0": // Current Year
				setStartDateEndDate(constants.startDateOfTheYear, constants.endDateOfTheYear);
				break;
			case "1": // Current Month
				setStartDateEndDate(constants.currentMonthSD, constants.currentMonthED);
				break;
			case "2": // Last Month
				setStartDateEndDate(constants.lastMonthSD, constants.lastMonthED);
				break;
			case "3": // Last 3 Months
				setStartDateEndDate(constants.lastThreeMonthSD, constants.lastThreeMonthED);
				break;
			case "4": // This Month Last Year
				setStartDateEndDate(constants.currentMonthLastYearSD, constants.currentMonthLastYearED);
				break;
			case "5": // Last 3 Months Last Year
				setStartDateEndDate(constants.lastthreemonthlastyearSD, constants.lastthreemonthlastyearED);
				break;
			case "6": // Previous Year
				setCurrentYear("all");
				setStartDateEndDate(constants.lastYearStartDate, constants.lastYearEndDate);
				break;
			case "7": // Last Year
				setStartDateEndDate(constants.startDateOfTheLastYear, constants.endDateOfTheLastYear);
				break;
			default:
				break;
		}
	};

	export const beforePdfUpload = (file) => {
		const isPdf = file.type === 'application/pdf'; 
		if (!isPdf) {
			message.error(constants.InvalidFileFormat);
			return Upload.LIST_IGNORE
		}
		// Check if the file size is less than 2MB
		const isLt2M = file.size / 1024 / 1024 < 2; 
		if (!isLt2M) {
			message.error('Maximum file size accepted is 2MB.');
			return Upload.LIST_IGNORE
		}
		return isPdf && isLt2M;
	};

	export const base64ToBlobUrl = (base64, mimeType = "application/pdf") => {
		const byteCharacters = atob(base64);
		const byteArrays = [];
	
		for (let i = 0; i < byteCharacters.length; i += 512) {
			const slice = byteCharacters.slice(i, i + 512);
			const byteNumbers = new Array(slice.length);
	
			for (let j = 0; j < slice.length; j++) {
				byteNumbers[j] = slice.charCodeAt(j);
			}
	
			const byteArray = new Uint8Array(byteNumbers);
			byteArrays.push(byteArray);
		}
	
		const blob = new Blob(byteArrays, { type: mimeType });
		return URL.createObjectURL(blob);
	};

	export const beforeVideoUpload = (file) => {
		const isMp4 = file.type === 'video/mp4';
		if (!isMp4) {
			message.error('Only MP4 video files are allowed.');
			return Upload.LIST_IGNORE;
		}
	
		const isLt200MB = file.size / 1024 / 1024 < 200;
		if (!isLt200MB) {
			message.error('Maximum file size accepted is 200MB.');
			return Upload.LIST_IGNORE;
		}
	
		return isMp4 && isLt200MB;
	};

	export const beforeAnimationUpload = (file) => {
		const isMp4 = file.type === 'image/gif';
		if (!isMp4) {
			message.error('Only GIF files are allowed.');
			return Upload.LIST_IGNORE;
		}
	
		const isLt200MB = file.size / 1024 / 1024 < 200;
		if (!isLt200MB) {
			message.error('Maximum file size accepted is 200MB.');
			return Upload.LIST_IGNORE;
		}
	
		return isMp4 && isLt200MB;
	};